import React from 'react';







class Navidad extends React.Component {
    render() {
        return (
            <React.Fragment>



                


                <div className="Luna"></div>


                <div className="Tierra">


                    <div className="Muneco">

                        <div className="MunecoBody">


                            <div className="Cabeza">
                                <div className="ojoD">


                                </div>

                                <div className="ojoI">


                                </div>

                                <div className="Nariz">


                                </div>

                                <div className="Boca">


                                </div>

                            </div>
                            <div className="Pecho">


                            </div>
                            <div className="Piez">
                            </div>


                        </div>

                    </div>



                    <div className="TierraUno">

                        <div >
                            <svg viewBox="0 0 500 150" preserveAspectRatio="none"
                            >
                                <path d="M-43.16,36.03 C54.46,173.20 397.57,12.34 555.01,80.44 L500.00,150.00 L0.00,150.00 Z"
                                ></path>
                            </svg>
                        </div>

                    </div>


                    <div className="TierraDos">

                        <div >
                            <svg viewBox="0 0 500 150" preserveAspectRatio="none"
                            >
                                <path d="M-27.93,141.63 C49.38,-43.89 258.17,217.61 551.63,42.94 L500.00,150.00 L0.00,150.00 Z"
                                ></path>
                            </svg>
                        </div>

                    </div>


                    <div className="TierraTres">

                        <div >
                            <svg viewBox="0 0 500 150" preserveAspectRatio="none"
                            >
                                <path d="M-86.05,88.33 C313.48,231.42 139.67,-160.34 442.15,84.38 L631.77,205.77 L0.00,150.00 Z"
                                ></path>
                            </svg>
                        </div>

                    </div>
                </div>


                <div className="Nieve">



                    <h1 className="MerryChristmas">Merry Christmas</h1>



                </div>

               

            </React.Fragment>
        );
    }
}

export default Navidad;